import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { ImageModalComponent } from 'src/app/layout/components/image-modal/image-modal.component';
import { Authority } from 'src/app/shared/config/authority.constants';
import { AuthServerProvider } from 'src/app/shared/services/auth-jwt.service';
import { ScrollService } from 'src/app/shared/services/scroll.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-nav-bar-home',
    templateUrl: './nav-bar-home.component.html',
    styleUrls: ['./nav-bar-home.component.scss'],
    standalone: true,
    imports: [RouterLink, NgClass, RouterLinkActive, TranslateModule]
})

export class NavBarHomeComponent implements OnInit {
    @Input() navType: string;
    active: boolean;
    routerUrl;

    constructor(
        private authService: AuthServerProvider,
        private $sessionStorage: SessionStorageService,
        private router: Router,
        private dialog: MatDialog,
        public translate: TranslateService,
        public scrollService: ScrollService) {
    }

    ngOnInit(): void {
        if (this.translate.currentLang === 'pt') {

            this.active = true;
            return;
        }

        this.active = false;

    }

    openSelo(){
        this.dialog.open(ImageModalComponent, {
            data: {title: "Selo Jiantan", src: "./../../../../assets/site/ICONS/selo2024.png", url: "https://jiantan.com.br/site/MTMxMQ=="}
            // width: '250px'
          });
    }

    isNotHome() {
        return this.router.url.includes("/site/");
    }

    isNotAnyRoute() {
        return !this.router.url.includes("/");
    }

    isNotLogin() {
        return !this.router.url.includes("/site/login");
    }

    setActive() {
        if (this.translate.currentLang === 'pt') {
            this.translate.use('en');
        } else {
            this.translate.use('pt');
        }
        this.active = !this.active;
    }

    isOptionFromNav() {
        if (this.navType === 'white') {
            return true;
        };

        return false;

    }

    isLoggedIn() {
        let token = this.$sessionStorage.retrieve("authenticationToken");
        if (token) {
            return true;
        }
        return false;
    }

    navigateIfLoggedIn() {
        let authority;
        this.authService.getCurrentUser().subscribe(x => {
            if (x) authority = x.auth;
        })
        if (this.isLoggedIn()) {
            if (authority.includes(Authority.PRODUTOR)) this.router.navigate(["/dashboard"]);
            if (authority.includes(Authority.COMPRADOR)) this.router.navigate(["/dashboard-comprador"]);
            if (authority.includes(Authority.ADMIN)) this.router.navigate(["/dashboard-adm"]);
            return;
        }
        this.router.navigate(["/site/login"]);
    }

    scrollOnClick(scrollTo: string) {
        this.router.navigate(['/site/solucoes']).then( () => {
        this.scrollService.scroll.next(scrollTo);
        })
    }
}
